// Copyright (c) Ensho Health, 2021 to present

import { OktaAuth } from '@okta/okta-auth-js';

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI,
  storageManager: {
    token: {
      storageType: 'cookie'
    },
    cache: {
      storageTypes: ['localStorage', 'sessionStorage', 'cookie']
    },
    transaction: {
      storageTypes: ['sessionStorage', 'localStorage', 'cookie']
    }
  }
});

export const oktaClient = oktaAuth;

const ERROR_MESSAGES = {
  MFA_FACTOR_NOT_SUPPORTED:
    'Your account has multi-factor authentication enabled for a ' +
    'factor type not supported by this application. Please contact ' +
    'an Ensho administrator to revolve this issue.'
};
export async function handleMFARequired(transaction) {
  let pushFactor = transaction.factors.find((factor) => {
    return factor.provider === 'OKTA' && factor.factorType === 'push';
  });
  if (pushFactor) {
    const newTransaction = await pushFactor.verify({ autoPush: true });
    return newTransaction;
  } else {
    throw new Error(ERROR_MESSAGES.MFA_FACTOR_NOT_SUPPORTED);
  }
}

export async function handleMFAChallenge(transaction) {
  if (
    transaction.factor.provider === 'OKTA' &&
    transaction.factor.factorType === 'push'
  ) {
    const newTransaction = await transaction.poll();
    return newTransaction;
  } else {
    throw new Error(ERROR_MESSAGES.MFA_FACTOR_NOT_SUPPORTED);
  }
}

export async function handleMFAEnroll(transaction) {
  let pushFactor = transaction.factors.find((factor) => {
    return factor.provider === 'OKTA' && factor.factorType === 'push';
  });
  if (pushFactor) {
    const newTransaction = await pushFactor.enroll({ autoPush: true });
    return newTransaction;
  } else {
    throw new Error(ERROR_MESSAGES.MFA_FACTOR_NOT_SUPPORTED);
  }
}

export async function handleMFAEnrollActivate(transaction) {
  if (
    transaction.factor.provider === 'OKTA' &&
    transaction.factor.factorType === 'push'
  ) {
    const newTransaction = await transaction.poll();
    return newTransaction;
  } else {
    throw new Error(ERROR_MESSAGES.MFA_FACTOR_NOT_SUPPORTED);
  }
}
